const termsOfUse = {
  content: `<v-layout row wrap>
  <v-flex xs12>
    <b></b>
    <p class="body-1" style="text-align: justify">
      The present terms and
      <b>Terms of Use, and Privacy Policy</b>, regulate the
      use of,
      <b>WEBSITE:</b>
      <a href="https://www.fbase.tv" target="_blank">
        <u>http://www.fbase.tv</u>
      </a> , from which,
      <b>GLOSPEN, SL</b>, with
      <b>NIF: L-713690W</b>, residing in:
      <b>CTRA. DE LA PLANA, EDIF. MIRADOR PARC, B-II, 5º 2ª</b>, Postal Code:
      <b>AD700</b>. Location:
      <b>ESCALDES-ENGORDANY, ANDORRA</b>, it is
      headline.
    </p>
    <p class="body-1" style="text-align: justify">
      Through its
      <b>WEBSITE</b>,
      <a href="https://www.fbase.tv" target="_blank">
        <u>http://www.fbase.tv</u>
      </a> , from,
      <b>GLOSPEN, SL</b>, on, the
      web page administrator. Due to the content and purpose of the
      <b>WEBSITE</b>, the
      people who want information or purchase of our matches, must register
      in the form of,
      <b>USERS / CUSTOMERS</b>, which is acquired by completing the
      form of
      <b>REGISTRY</b>, Your data will be incorporated into an automated file,
      as stated in article 13 of the General Data Protection Regulation-
      EU-2016/679, of the Parliament and Council of Europe, of, April 27, 2016, by the
      Organic Law 3/2018, on the Protection of Personal Data and rights guarantees
      Digital and the application of Directive 2011/83 / EU of 25 October on the
      consumer rights
    </p>

    <ol style="text-align: justify" class="mb-3">
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>INFORMATION ABOUT THE WEB</u>
        </li>
        <p class="body-1">
          The
          <b>WEBSITE:</b>
          <a href="https://www.fbase.tv" target="_blank">
            <u>http://www.fbase.tv</u>
          </a> , of which he is Administrator,
          <b>GLOSPEN, SL</b>, from
          the platform
          <b>fbase.tv</b>, for the issuance of football matches of different categories in
          Direct, undefeated or viewing videos of the players themselves for promotion.
        </p>
      </div>
      <div>
        <p class="body-2 font-weight-bold">
          <u>ADVERTISING</u>
        </p>
        <p class="body-1">
          The Website:
          <a href="https://www.fbase.tv" target="_blank">
            <u>http://www.fbase.tv</u>
          </a> , may host advertising content or
          sponsored. Advertisers or sponsors are solely responsible for
          ensure that the material submitted for inclusion on the Web complies with the laws
          that in each case may be applicable.
          <b>GLOSPEN, SL</b> will not be responsible for
          any error, inaccuracy or irregularity that the contents may contain
          advertising or sponsors.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>AVAILABILITY</u>
        </li>
        <p class="body-1">
          The website administrator will do everything possible to resolve all doubts and
          procedures requested from all its
          <b>USERS / CUSTOMERS</b>, as soon as possible
          in the demand of the consultations.
        </p>
        <p class="body-1">
          However, sometimes, and for reasons hardly controllable by the administrator
          of the website as human errors or incidents in computer systems, is
          it is possible that the speed finally served the
          <b>USERS / CUSTOMERS</b>, differs from the orders of
          <b>USERS / CUSTOMERS</b>.
        </p>
        <p class="body-1">
          In the event that management is not available or could not be finalized,
          After making the reservation, the
          <b>USER / CUSTOMER</b>, will be informed by
          email of the total cancellation of this one.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>SECURITY</u>
        </li>
        <p class="body-1">
          The website administrator has the maximum security measures
          commercially available in the sector. In addition, the payment process works on
          a secure server using the SSL protocol. The secure server establishes a
          connection so that the information is transmitted encrypted using algorithms of 128
          bits, which ensure that it is only intelligible and understandable by the computer of the
          <b>USER / CUSTOMER</b>, y el del
          <b>WEBSITE</b>, In this way, when using the SSL protocol,
          guarantees:
        </p>
        <ol class="mb-3">
          <li>
            That he
            <b>USER / CUSTOMER</b>, is communicating your data to the server center of the
            administrator of the website and not any other who tried to impersonate
            East.
          </li>
          <li>
            That between
            <b>USER / CUSTOMER</b>, and the server center of the administrator of the
            Web page data is transmitted encrypted, preventing its possible reading or
            third party manipulation.
          </li>
        </ol>
        <p class="text-xs-center body-2 font-weight-bold">
          <u>CERTIFICATES OF COMPLIANCE LSSI-CE AND DATA PROTECTION</u>
        </p>
        <p class="body-1">
          <b>GLOSPEN, SL</b>, of which you own the website,
          <a href="https://www.fbase.tv" target="_blank">
            <u>http://www.fbase.tv</u>
          </a> , meets the
          European Data Protection regulations in force and with the LSSI-CE, and is advised
          in these regulations by GRUPO QUALIA, so they are given two
          certificates in digital image format so you can display them on your website.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>INTELLECTUAL AND INDUSTRIAL PROPERTY</u>
        </li>
        <p class="body-1">
          The administrator of the website has all rights to the content, design
          and source code of this website,
          <a href="https://www.fbase.tv" target="_blank">
            <u>http://www.fbase.tv</u>
          </a> , and especially with character
          but not limited to photographs, images, texts, logos, designs,
          trademarks, trade names and data included in the web.
        </p>
        <p class="body-1">
          It warns
          <b>USERS / CUSTOMERS</b>, that these rights are protected by the
          current European and international legislation regarding intellectual property and
          industrial. Likewise, and notwithstanding the foregoing, the content of the
          <b>WEBSITE</b>,
          It is also considered a computer program, and therefore it is
          also applicable all the European Community regulations in force in the matter.
        </p>
        <p class="body-1">
          It is expressly forbidden the total or partial reproduction of this website, nor of
          any of its contents, without the express and written permission of the administrator of
          the website.
        </p>
        <p class="body-1">
          Likewise, copying, reproduction, adaptation, modification,
          distribution, commercialization, public communication and / or any other action that
          report a violation of current regulations on intellectual property
          and / or industrial, as well as the use of the contents of the web if not with the previous
          express and written authorization of the administrator.
        </p>
        <p class="body-1">
          The administrator of the website informs that he does not grant a license or authorization
          implied on intellectual and / or industrial property rights or on any
          other right or property related, directly or indirectly, to the contents
          included in the
          <b>WEBSITE</b>:
          <a href="https://www.fbase.tv" target="_blank">
            <u>http://www.fbase.tv</u>
          </a>
        </p>
        <p class="body-1">
          Only the use of the contents of the web domain is authorized for informational purposes
          and of service, whenever the source is cited or referenced, the user being the
          solely responsible for their misuse.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>ACCESS AND STAY ON THE WEB</u>
        </li>
        <p class="body-2 font-weight-bold">
          <u>OUR CONTENTS</u>
        </p>

        <p class="body-1">
          The USER / CUSTOMER, are fully responsible for their conduct, when accessing
          to the information of the
          <b>WEBSITE</b>, as long as they're sailing in it, as well as after
          if I'd agreed to it.
        </p>
        <p class="body-1">
          As a result, the
          <b>USERS / CUSTOMERS</b>, are solely responsible
          before the webmaster and third parties of:
        </p>

        <ol>
          <li class="mb-2">
            The consequences that may arise from a use, for purposes or with effects
            illegal or contrary to this document, of any content of the
            <b>WEBSITE</b>,
            prepared or not by the webmaster of the website, published or not under his
            name officially.
          </li>
          <li class="mb-2">
            As well as the consequences that may arise from the use contrary to the
            content of this document and prejudicial to the interests or rights of
            third parties, or that in any way could damage, disable or deteriorate the SITE
            WEB, or its services or prevent the normal enjoyment by other users.
          </li>
        </ol>
        <p class="body-1">
          The website administrator reserves the right to update the contents
          when it deems appropriate, as well as eliminating, limiting or preventing access to
          them, either temporarily or permanently, as well as to deny access to the
          <b>WEBSITE</b> a
          <b>USERS / CUSTOMERS</b>, that misuse the contents and/or fail to
          any of the terms and conditions contained herein.
        </p>
        <p class="body-1">The website administrator informs that he does not guarantee:</p>
        <ol>
          <li class="mb-2">
            That access to the
            <b></b>, and/or to the linking sites whether uninterrupted or free of
            mistake.
          </li>
          <li class="mb-2">
            That the content or software to which the
            <b>USERS / CUSTOMERS</b>, access through
            the website or the linked websites do not contain any errors, computer viruses or other
            elements in the contents that can produce alterations in your system or in the
            electronic documents and files stored on your computer system or cause
            another kind of damage.
          </li>
          <li class="mb-2">
            The use that the information or content of the
            <b>WEBSITE</b>, or websites of
            link that the
            <b>USER / CUSTOMER</b>, could do for their purposes
            personal.
          </li>
        </ol>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>OUR RESPONSIBILITY</u>
        </li>
        <p class="body-1">
          The WEBSITE administrator does not assume any responsibility derived, as
          Not limited to, but not limited to:
        </p>
        <p class="body-1">
          Of the use that the
          <b>USER / CUSTOMER</b>, can make the materials of the
          <b>if</b> or link sites, whether prohibited or permitted, in violation of the
          intellectual and/or industrial property rights to the contents of the
          <b>WEBSITE</b>, or from
          third parties.
        </p>
        <p class="body-1">
          Any damages to the
          <b>USER / CUSTOMER</b>, caused by a
          normal or abnormal functioning of the search tools, the organization
          o the location of the contents and/or access to the
          <b</b>, and, in general, the errors
          o problems that are generated in the development or implementation of the elements
          technicians that the
          <b>IF</b>, or a program that facilitates the
          <b>USER / CUSTOMER</b>.
        </p>
        <p class="body-1">
          Of the contents of those pages to which
          <b>USERS / CUSTOMERS</b>, can
          access from links included in the
          <b>S</b>, whether they're authorized or not.
        </p>
        <p class="body-1">
          The acts or omissions of third parties, regardless of whether these third parties could
          be linked to the website administrator by contract.
        </p>
        <p class="body-1">
          Access by minors to the contents included in the
          <b>WEBSITE</b>, where
          responsibility of their parents or guardians to exercise adequate control over the
          activity of the children or minors in their care or install one of the tools
          control the use of the Internet for the purpose of preventing access to materials or
          contents not suitable for minors, as well as the sending of personal data without
          with prior permission from their parents or guardian.
        </p>
        <p class="body-1">
          The website administrator will not be responsible in any case when
          produce:
        </p>
        <ul>
          <li class="mb-2">
            Errors or delays in access to the
            <b>WEBSITE</b>, on the part of the
            <b>USER / CUSTOMER</b>, when entering your data in the
            services, the slowness or impossibility of reception by the
            recipients of the order confirmation or any anomaly that may
            arise when these incidents are due to problems on the Internet,
            causes of fortuitous event or force majeure and any other contingency
            unpredictable and unrelated to the good faith of the webmaster.
          </li>
          <li class="mb-2">
            Errors or incidents that may occur in communications, deletion
            or incomplete transmissions, so there is no guarantee that the services
            of the WEBSITE are constantly operational.
          </li>
          <li class="mb-2">
            Of the non-operativity or problems in the electronic address provided by the
            <b>USER / CUSTOMER</b>, to send the confirmation of the order for services.
          </li>
        </ul>
        <p class="body-1">
          In any case, the website administrator commits himself to solve the
          problems that may arise and to provide all necessary support to the
          <b>USER / CUSTOMER</b>, to reach a rapid and satisfactory resolution of the incident.
        </p>
        <p class="body-1">
          In addition, the website administrator has the right to perform during
          defined time intervals, promotional campaigns to promote the registration of
          new members in your service.
        </p>
        <p class="body-1">
          The website administrator reserves the right to modify the conditions
          of application of the promotions, to extend them by due notice, or to proceed to
          exclusion of any of the
          <b>USERS / CUSTOMERS</b>, of the promotion in the event
          to detect any anomaly, abuse or unethical behaviour in the participation
          of the same.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>PRIVACY POLICIES</u>
        </li>
        <p class="body-1">
          The
          <b>USERS / CUSTOMERS</b> are committed to navigate the
          <b>WEBSITE/b> and to use
          the content of good faith.
        </p>
        <p class="body-1">
          In compliance with the provisions of the General Regulations on Data Protection-
          UE-2016/679, and the LOPD-3/2018 of digital rights guarantee, we inform you
          that the completion of any existing form in the
          <b>WEBSITE/b>,
          <a href="https://www.fbase.tv" target="_blank">
            <u>http://www.fbase.tv</u>
          </a> , or the forwarding of an email to any of our
          The use of the mailboxes implies the acceptance of this privacy policy, as well as the
          to the website administrator to process the personal data you provide,
          which will be incorporated into the file, owned by the Data Controller and/or
          website administrator.
        </p>
        <p class="body-1">
          The data of the
          <b>USERS / CUSTOMERS</b>, will be used for shipment through
          e-mail of the online management, made by the administrator of the page
          web.
        </p>
        <p class="body-1">
          For the mere visit to the
          <b>WEBSITE/b>, the
          <b>USERS / CUSTOMERS</b>, do not provide information
          personal nor is he obliged to provide it.
        </p>
        <p class="body-1">
          The website administrator agrees to keep the maximum reserve and
          confidentiality of the information provided to you and to use it only
          for the purposes indicated.
        </p>
        <p class="body-1">
          The website administrator assumes that the data has been entered by your
          or by a person authorized by the holder, and that they are correct and accurate.
        </p>
        <p class="body-1">
          These data will be introduced in an automated file under the responsibility of the
          webmaster of
          <b>GLOSPEN, SL</b>, in order to be able to facilitate, speed up and
          to fulfil the commitments established between the two parties.
        </p>
        <p class="body-1">
          Also,
          <b>GLOSPEN, SL</b>, informs of the possibility of exercising the rights of
          <b>access</b>, that allows the web user to know what personal data the
          administrator of this page and in that case will answer within 30 days, always
          to keep the data,
          <b>Correction</b>, which allows you to correct errors, change data
          that are inaccurate or incomplete and ensure the accuracy of the information,
          <b>opposition</b>
          who may request and obtain that you do not carry out data processing,
          <b>deletion</b>
          which allows inappropriate or excessive data to be deleted,
          <b>limitación</b>, by the
          that you may request to limit the processing of your data when you have exercised your
          the right to rectify your personal data, and
          <b>portability</b>, so that the user
          can obtain a copy of the personal data you have provided on the website in order to
          to other services, these rights may be exercised by any
          means of leaving a record of its dispatch and receipt at the address:
          <b>CTRA. DE LA PLANA, EDIF. MIRADOR PARC, B-II, 5º 2ª</b>, Zip code:
          <b>AD700</b>, Location:
          <b>ESCALDES-ENGORDANY, PRINCIPALITY OF ANDORRA</b>, Email:
          <b>
            <u>Info@fbase.tv</u>
          </b>, providing a photocopy of the ID card or alternative documentation that proves
          his identity.
        </p>
        <p class="body-1">
          Until you inform us otherwise, we will understand that your data has not been
          modified, that you agree to notify us of any variations and that
          we have the consent to use them in order to be able to fidelize the relationship between
          parts.
        </p>
        <p class="body-1">
          Sending your data through the form(s) on our website will be subject to
          you must have read/accepted the Terms of Use , by means of a
          check box required at the bottom of the form.
        </p>
        <p class="body-1">
          In accordance with the provisions of Law 34/2002, of Services of the Company of the
          Information and Electronic Commerce in its article 21, we ask for your consent
          in order to make advertising communications that we believe may be of interest to you
          interest, by e-mail or by any other electronic means of communication
          equivalent, this consent will be accepted or denied with a mandatory check box at
          footer of the form.
        </p>
        <p class="body-1">
          For
          <b>modify</b>,
          <b>update</b> o
          <b>cancel</b> your personal data on
          <b>USER / CUSTOMER</b>,
          will write from your account email to:
          <b>
            <u>Info@fbase.tv</u>
          </b>, with the matter.
        </p>
        <p class="body-1">
          Therefore, the
          <b>USER/CUSTOMER</b> is responsible for the accuracy of the data and the
          The website administrator will not be responsible for the inaccuracy of the data
          personnel of the
          <b>USERS / CUSTOMERS</b>.
        </p>
        <p class="body-1">
          In accordance with current data protection legislation, the
          The website administrator has adopted the appropriate security levels for the
          data provided by the
          <b>USERS / CUSTOMERS</b> and, in addition, has installed all the
          means and measures at your disposal to prevent the loss, misuse, alteration, non
          and extraction of the same.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>NULIDAD</u>
        </li>
        <p class="body-1">
          In the event that any clause in these terms and conditions of use is
          declared null and void, the remaining clauses shall remain in force and shall be
          taking into account the will of the parties and the very purpose of those present
          terms and conditions.
        </p>
        <p class="body-1">
          The website administrator may not exercise any of the rights and
          powers conferred by this document which shall in no way imply the
          waiver of the same unless expressly acknowledged by the administrator of the
          website or prescription of the action that corresponds in each case.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>MODIFICATION OF THE TERMS AND CONDITIONS OF USE</u>
        </li>
        <p class="body-1">
          The website administrator reserves the right to modify, at any
          the presentation and configuration of the
          <b>WEBSITE/b>, as well as those present
          terms and conditions of use.
        </p>
        <p class="body-1">
          For this reason, the website administrator recommends
          <b>USER / CUSTOMER</b> read
          carefully the conditions and terms of use, each time you access the
          <b>WEBSITE/b>.
          The
          <b>USERS / CUSTOMERS</b>, will always have these terms and conditions of
          use in a visible place, freely accessible for as many consultations as you wish.
        </p>
      </div>
      <div>
        <li class="body-2 font-weight-bold pb-2">
          <u>APPLICABLE LAW AND ARBITRATION</u>
        </li>
        <p class="body-1">
        These terms and conditions of use are governed by Spanish law
        applicable in the matter. To resolve any controversy or conflict that may arise,
        the parties submit to the jurisdiction of the courts of
          <b>partido judicial</b> of,
          <b>ESCALDES-ENGORDANY, PRINCIPALITY OF ANDORRA</b>, of the city of origin of the
          company that owns the
          <b>WEBSITE/b> unless another jurisdiction is imposed by law.
        </p>
        <p class="body-1">
        For this reason, the website administrator recommends
          <b>USER / CUSTOMER</b> read
          carefully the conditions and terms of use, each time you access the
          <b>WEBSITE/b>.
          Los
          <b>USERS / CUSTOMERS</b>, will always have these terms and conditions of
          use in a visible place, freely accessible for as many consultations as you wish.
        </p>
      </div>
    </ol>
  </v-flex>
</v-layout>`,
}
export default termsOfUse
